import {session} from "./session.mjs";
import {subscribe} from "./subscribe.mjs";
import {
    deferNonCritical,
    disallowImagesDownload,
    offlineSupport,
    overlayScrollbar,
    shareButton,
    sideMenu,
} from "./utils.mjs";

window.addEventListener("beforeinstallprompt", event => event.preventDefault());

session();
sideMenu();
offlineSupport();

deferNonCritical(() => {
    subscribe();
    disallowImagesDownload();
    shareButton(document.getElementById("share-button"));
    overlayScrollbar();
});
